import React, { FC } from "react";
import { t } from "i18next";
import FeatherIcon from "feather-icons-react";
import { useNavigate } from "react-router-dom";

import { ConfirmationModal } from "@components/common";
import { Stack, Typography } from "@components/base";
import { useUserStore } from "@store/user";
import {
  useGetCsobDatasetComparison,
  useUpdateCompanyDataset,
  useUpdateUserModalViewedVersion,
} from "@api";

interface DatasetModal {
  isVisibleModal: boolean;
  handleCloseModal: () => void;
  datasetIndex: number;
}

export const DatasetModal: FC<DatasetModal> = ({
  isVisibleModal,
  handleCloseModal,
  datasetIndex,
}) => {
  const { user } = useUserStore();
  const { csobDatasetComparison } = useGetCsobDatasetComparison(user);
  const { updateUserModalViewedVersion } = useUpdateUserModalViewedVersion(user);
  const { updateCompanyDatasetAsync, isPendingUpdateCompanyDataset } =
    useUpdateCompanyDataset(user);

  const navigate = useNavigate();

  const handleConfirmModal = async (): Promise<void> => {
    await updateCompanyDatasetAsync({
      datasetIndex,
    });
    updateUserModalViewedVersion({
      modalDatasetViewedVersion:
        (csobDatasetComparison?.modalDatasetViewedVersion || 0) + 1,
    });
    handleCloseModal();
    navigate("/csob");
  };

  return (
    <ConfirmationModal
      open={isVisibleModal}
      onClose={handleCloseModal}
      onConfirm={handleConfirmModal}
      isLoading={isPendingUpdateCompanyDataset}
      title={
        <Stack spacing={2} alignItems="center" mb={2}>
          <FeatherIcon icon="info" size={32} />
          <Typography
            textAlign="center"
            component="div"
            fontWeight={700}
            fontSize={24}
          >
            {datasetIndex === 1
              ? t("csob.datasetComparison.modal.titleCsob")
              : t("csob.datasetComparison.modal.titleGreen0Meter")}
          </Typography>
        </Stack>
      }
      description={
        datasetIndex === 1
          ? t("csob.datasetComparison.modal.descriptionCsob")
          : t("csob.datasetComparison.modal.descriptionGreen0Meter")
      }
      cancelText={t("csob.datasetComparison.modal.button.cancel")}
      confirmText={t("csob.datasetComparison.modal.button.confirm")}
    />
  );
};
